import createItemsDuck from '@esentai/core/ducks/items';

import api from '../api';
import { getItemsRoot } from '../utils';

export default createItemsDuck('mall_stats_download_history', {
  api,
  getRoot: getItemsRoot,
});
